import axios from 'axios';

export default {
  alumno(idAlumno, idGrupo, idEvaluacion, idAsignatura, options = {}) {
    const opts = { ...options };
    opts.params = opts.params || {};
    // En esta llamada pasamos así el id de grupo porque es opcional, no podemos pasarle como
    // si fuera el id del panel
    opts.params.grupo_id = idGrupo;
    opts.params.alumno_id = idAlumno;
    opts.params.asignatura_id = idAsignatura;
    opts.params.evaluacion_id = idEvaluacion;
    // Cuando son de pendientes no hay grupo, nos pasan el cuaderno como una opción
    opts.params.cuaderno_id = options.idCuaderno;
    opts.params.visibles_tutor = options.mostrarVisiblesTutor;
    opts.params.visibles_familia = options.mostrarVisiblesFamilia;

    return axios.get('/cuadernos/items_publicos/alumno', opts, options);
  },
};
